import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { t } from '@lib/translation';

import { SnFormFieldConfig } from '../../types/form-field-config.type';

@Component({
  selector: 'sn-edit-field-dialog',
  templateUrl: './edit-field-dialog.component.html',
  styleUrls: ['./edit-field-dialog.component.scss'],
})
export class EditFieldDialogComponent implements OnInit {
  public form = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [
    {
      templateOptions: {
        label: t('form.field'),
      },
      wrappers: ['form-field-group'],
      fieldGroup: [
        {
          fieldGroupClassName: 'form-field-row',
          fieldGroup: [
            {
              key: 'fieldType',
              type: 'select',
              className: 'form-field-col',
              templateOptions: {
                label: t('form.fieldType'),
                placeholder: t('form.selectFieldType'),
                required: true,
                options: [
                  { label: t('form.smallText'), value: 'smallText' },
                  { label: t('form.textArea'), value: 'textArea' },
                  { label: t('form.dropDown'), value: 'select' },
                ],
              },
            },
            {
              key: 'fieldName',
              type: 'input',
              className: 'form-field-col',
              templateOptions: {
                label: t('form.fieldName'),
                placeholder: t('form.enterFieldName'),
                required: true,
                disabled: true,
              },
            },
            {
              key: 'validation',
              type: 'select',
              className: 'form-field-col',
              templateOptions: {
                label: t('form.validation'),
                placeholder: t('form.noValidation'),
                options: [
                  { label: t('form.noValidation'), value: null },
                  { label: t('form.alphaOnly'), value: 'alpha' },
                  { label: t('form.alphanumericOnly'), value: 'alphanumeric' },
                ],
              },
              hideExpression: () => this.formModel.fieldType !== 'smallText',
            },
          ],
        },
        {
          fieldGroupClassName: 'form-field-row',
          fieldGroup: [
            {
              key: 'minLength',
              type: 'input',
              className: 'form-field-col-6',
              templateOptions: {
                label: t('form.minCharacterLength'),
                placeholder: t('form.enterMinCharacterLength'),
                type: 'number',
              },
              hideExpression: () => this.formModel.fieldType === 'select',
            },
            {
              key: 'maxLength',
              type: 'input',
              className: 'form-field-col-6',
              templateOptions: {
                label: t('form.maxCharacterLength'),
                placeholder: t('form.enterMaxCharacterLength'),
                type: 'number',
              },
              hideExpression: () => this.formModel.fieldType === 'select',
            },
          ],
        },
      ],
    },
    {
      type: 'checkbox',
      key: 'required',
      className: 'form-field-col-4',
      templateOptions: {
        label: t('form.required'),
      },
    },
    {
      type: 'checkbox',
      key: 'hideInList',
      className: 'form-field-col-4',
      templateOptions: {
        label: t('form.hideInList'),
        defaultValue: false,
      },
    },
    {
      templateOptions: {
        label: t('common.options'),
      },
      hideExpression: () => this.formModel.fieldType !== 'select',
      wrappers: ['form-field-group'],
      fieldGroup: [
        {
          key: 'options',
          type: 'repeat',
          templateOptions: {
            addText: t('form.addOption'),
          },
          fieldArray: {
            fieldGroupClassName: 'form-field-row',
            fieldGroup: [
              {
                key: 'option',
                type: 'input',
                className: 'form-field-col-12',
                templateOptions: {
                  label: t('form.option'),
                  placeholder: t('form.enterOption'),
                  required: true,
                },
              },
            ],
          },
        },
      ],
    },
  ];

  constructor(
    private readonly _dialogRef: MatDialogRef<EditFieldDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  public ngOnInit(): void {
    this.editField();
  }

  public submitForm(): void {
    this._dialogRef.close(this.formModel);
  }

  public editField(): void {
    if (this.data) {
      this.formModel = {
        ...this.data,
      };
    }
  }
}
